/**
 * Created by WorkAxis www.workaxis.in
 * Contact form — submits leads directly to AntCRM.
 *
 * NOTE: these API credentials are shipped in the public JS bundle and are
 * visible to anyone. Use a restricted, lead-creation-only key here and
 * rotate it if abused — or move this call behind a small server-side proxy.
 */
import React, {useState} from 'react';
import {contactInterests} from "./data";

const ANTCRM_CLIENT_ID = 'pk_vEc5wnCZ1ph6OKovcKW-Vx3Krnn5pIoyKkm4JQN09x8';
const ANTCRM_CLIENT_SECRET = 'sk_lKyElYp-PSCWpcQCR9LoP6ALf4DFqzN788PKxtWavydW9vQIhh4_6Rsh3pBj_o04';
const ANTCRM_LEADS_URL = 'https://api.antcrm.co/api/v1/leads/';
const ANTCRM_STATUS_NEW = 'workaxis' //'ca69ff19-487b-45c0-ac1d-54e27542c57a';

const AUTH_HEADER = 'Basic ' + btoa(`${ANTCRM_CLIENT_ID}:${ANTCRM_CLIENT_SECRET}`);

const initialForm = {
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    company: '',
    interest: '',
    message: ''
};

export default function ContactForm() {
    const [form, setForm] = useState(initialForm);
    const [status, setStatus] = useState('idle'); // idle | sending | success | error

    const onChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value});
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        if (status === 'sending') return;
        setStatus('sending');

        let timezone = 'Asia/Calcutta';
        try {
            timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || timezone;
        } catch (ignored) {
        }

        const customFields = [];
        if (form.company.trim()) customFields.push({name: 'Company', value: form.company.trim()});
        if (form.interest.trim()) customFields.push({name: 'Interest', value: form.interest.trim()});
        if (form.message.trim()) customFields.push({name: 'Message', value: form.message.trim()});

        const client = {
            is_converted: false,
            timezone,
            first_name: form.firstName.trim(),
            last_name: form.lastName.trim(),
            email: form.email.trim(),
            source: 'website',
            status: ANTCRM_STATUS_NEW,
            custom_fields: customFields
        };
        const mobileDigits = form.mobile.replace(/\D/g, '');
        if (mobileDigits) client.mobile = mobileDigits;

        try {
            const res = await fetch(ANTCRM_LEADS_URL, {
                method: 'POST',
                headers: {
                    'Authorization': AUTH_HEADER,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({client})
            });
            const data = await res.json().catch(() => ({}));
            if (!res.ok || data.error) throw new Error(data.message || 'Request failed');
            setStatus('success');
            setForm(initialForm);
        } catch (err) {
            setStatus('error');
        }
    };

    if (status === 'success') {
        return (
            <div className="wx-form-result">
                <div className="wx-form-result-icon">✓</div>
                <h3>Thank you — we've received your message.</h3>
                <p>Our team will get back to you within one business day.</p>
                <button type="button" className="wx-btn wx-btn-ghost"
                        onClick={() => setStatus('idle')}>Send another message
                </button>
            </div>
        );
    }

    return (
        <form className="wx-form" onSubmit={onSubmit}>
            <div className="wx-form-grid">
                <label className="wx-field">
                    <span>First name *</span>
                    <input name="firstName" value={form.firstName} onChange={onChange}
                           required autoComplete="given-name" placeholder="Shan"/>
                </label>
                <label className="wx-field">
                    <span>Last name</span>
                    <input name="lastName" value={form.lastName} onChange={onChange}
                           autoComplete="family-name" placeholder="Raj"/>
                </label>
                <label className="wx-field">
                    <span>Email *</span>
                    <input name="email" type="email" value={form.email} onChange={onChange}
                           required autoComplete="email" placeholder="you@company.com"/>
                </label>
                <label className="wx-field">
                    <span>Mobile</span>
                    <input name="mobile" type="tel" value={form.mobile} onChange={onChange}
                           autoComplete="tel" placeholder="+91 98765 43210"/>
                </label>
                <label className="wx-field is-full">
                    <span>Company</span>
                    <input name="company" value={form.company} onChange={onChange}
                           autoComplete="organization" placeholder="Your company name"/>
                </label>
                <label className="wx-field is-full">
                    <span>What are you looking for?</span>
                    <select name="interest" value={form.interest} onChange={onChange}>
                        <option value="">Select an area (optional)</option>
                        {contactInterests.map((opt) => (
                            <option key={opt} value={opt}>{opt}</option>
                        ))}
                    </select>
                </label>
                <label className="wx-field is-full">
                    <span>Describe your workflow or idea</span>
                    <textarea name="message" value={form.message} onChange={onChange}
                              rows={4}
                              placeholder="What manual process or product are you trying to solve? Which tools do you use today?"/>
                </label>
            </div>

            {status === 'error' && (
                <div className="wx-form-error">
                    Something went wrong while sending your message. Please try again, or email
                    us directly at <a href="mailto:hello@workaxis.in">hello@workaxis.in</a>.
                </div>
            )}

            <button type="submit" className="wx-btn wx-btn-primary wx-form-submit"
                    disabled={status === 'sending'}>
                {status === 'sending' ? 'Sending…' : 'Send message'}
            </button>
        </form>
    );
}
